import api from 'Application/api/api';

const deleteEntityComment = (signal, deletedEntityCommentId) =>
	api.delete(`/contract-party-comments/${deletedEntityCommentId}`, {
		signal,
	});

export default deleteEntityComment;
